import {Badge, Modal} from 'antd'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import WoGContext from "../WoGContext";
import {godwords_getMeditations_Api, godwords_getWordsOfGod_Api} from "../../../../apis/godwords";
import {GodWordItem} from "../components/GodWordItem";
import {renderIf, renderIfElse} from "../../../Shared";
import EmptyHolder from "../../../../components/EmptyHolder";
import CodiContext, {CodiProvider} from "../../Codi/CodiContext";
import {GiIronCross, GiSpellBook} from "react-icons/gi";
import Translate from "../../../../modules/local/Translate";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {useGodWords} from "../functions/useGodWords";
import {TagCloudWoGHashTags} from "../components/TagCloudWoGHashTags";
import {BsLink} from "react-icons/bs";
import {FaCircleInfo, FaHashtag} from "react-icons/fa6";
import {FaPrayingHands} from "react-icons/fa";
import {GoDotFill} from "react-icons/go";
import Toggle from "../../../../components/Toggle";
import {RiDoubleQuotesL, RiDoubleQuotesR} from "react-icons/ri";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {convertFromString} from "../../../SlateEditor/functions";
import {SlateRenderer} from "../../../SlateEditor";
import _ from 'lodash'
import {MdTopic} from "react-icons/md";
import {BiSolidNetworkChart} from "react-icons/bi";


const BlockWrapper = ({style, className, children}) => (
  <div
    style={style}
    className={classNames('flex flex-col gap-2 p-2', className)}>
    {children}
  </div>
)

const Block = ({header = null, params, children, ...props}) => {
  const Icon = params?.Icon

  return (
    <BlockWrapper {...props}>
      {header ?? header}
      {children}
    </BlockWrapper>
  )
}

export const WoGLinkedByHashTag = ({
                                     style,
                                     style2,
                                     className,
                                     className2,
                                     header = null,
                                     hideOnEmpty = false,
                                   }) => {
  const t = useTranslate()
  const {item} = useContext(WoGContext);
  const {hashtags} = item || {};

  const apiInfo = godwords_getWordsOfGod_Api

  const refreshKey = useMemo(
    () => [apiInfo?.path, hashtags].join('/'),
    [hashtags]
  )

  const {
    modal,
    handleAction,
    onVote,
    onDevote
  } = useGodWords({})

  return (
    <div style={style} className={classNames('flex flex-col', className)}>
      {header}
      <div
        style={style2}
        className={classNames('flex flex-col gap-3', className2)}>
        {renderIfElse(
          item && hashtags,
          <EntityList
            apiInfo={apiInfo}
            refreshKey={refreshKey}
            values={{hashtags}}
            RenderEntity={React.Fragment}
            renderItem={item => (
              <GodWordItem
                labelSize="font-medium text-sm"
                item={item}
                edit={true}
                {...{handleAction, onVote, onDevote}}
              />
            )}
          />,
          <div className="border border-color-50 rounded-lg">
            <EmptyHolder/>
          </div>
        )}
      </div>
      {modal}
    </div>
  )
}

export const WoGByHashTag = ({
                               style,
                               style2,
                               className,
                               className2,
                               header = null,
                               hashtags = null
                             }) => {
  const apiInfo = godwords_getWordsOfGod_Api

  const wog_hashtags = useRouteSearchParam("wog_hashtags");
  const selTags = !!wog_hashtags ? wog_hashtags : hashtags
  const refreshKey = useMemo(
    () => [apiInfo.path, selTags].join('/'),
    [selTags]
  )

  return (
    <div style={style} className={classNames('flex flex-col', className)}>
      {header}
      <div
        style={style2}
        className={classNames('flex flex-col gap-3', className2)}>
        <EntityList
          apiInfo={apiInfo}
          refreshKey={refreshKey}
          values={{hashtags: selTags}}
          RenderEntity={React.Fragment}
          renderItem={item => (
            <GodWordItem
              labelSize="font-medium text-sm"
              item={item}
            />
          )}
        />
      </div>
    </div>
  )
}


export const BookLinkedByWoG = ({
                                  style,
                                  style2,
                                  className,
                                  className2,
                                  header = null,
                                  hideOnEmpty = false,
                                }) => {
  const t = useTranslate()
  const {item} = useContext(WoGContext);
  const {codi_document_row} = item ?? {};
  const {codi_document, content, index_cd} = codi_document_row ?? {};

  return (
    <CodiProvider
      id={item?.codi_document_row?.codi_document?.id}
      page_id={item?.codi_document_row?.codi_document_page?.id}>
      <CodiContext.Consumer>
        {({...bookProps}) => {
          const {current_row} = bookProps ?? {}
          return (
            <div className={classNames('flex flex-col', className)}>
              {header}
              <div className="flex flex-col gap-3">
                <ItemInformation
                  className="text-xs"
                  label={t('book name')}
                  value={`${codi_document?.title} (${codi_document?.document_no})`}
                />
                <ItemInformation
                  className="text-xs"
                  label={t('chapter')}
                  value={current_row?.short_index_name}
                />
                <ItemInformation
                  className="text-xs"
                  label={t('sentence-cd')}
                  value={index_cd}
                />
                <div className="flex flex-col gap-1 italic text-xs">
                  <span className="text-color-500 whitespace-no-wrap">{`${t('content')} : `}</span>
                  <span className="ml-2 font-bold text-color-100">
                                {content}
                            </span>
                </div>
              </div>
            </div>
          )
        }}
      </CodiContext.Consumer>
    </CodiProvider>
  )
}


export const WoGMeditaions = ({
                                style,
                                style2,
                                className,
                                className2,
                                header = null,
                                hideOnEmpty = false,
                              }) => {
  const t = useTranslate()
  const {item} = useContext(WoGContext);
  const apiInfo = godwords_getMeditations_Api

  const refreshKey = useMemo(
    () => [apiInfo.path, item?.id].join('/'),
    [item]
  )

  const ContentModal = ({item, index}) => {
    const {title, source_text, description, content, meditation, meditation_content} = item ?? {}

    const ContentWordOfGod = ({content}) => (
      <div className="flex flex-col mb-8">
        <div className="flex flex-center gap-2">
          <span style={{color: '#ccc'}}>{'------'}</span>
          <span className="font-bold text-base text-color-500 uppercase tracking-widest">
                        {t('content word of god')}
                    </span>
          <span style={{color: '#ccc'}}>{'------'}</span>
        </div>
        <div className="flex flex-col items-center gap-1 my-2">
          <div className="text-center font-bold text-lg text-primary italic">
            <RiDoubleQuotesL size={14} className="mr-1 mb-1"/>
            {content}
            <RiDoubleQuotesR size={14} className="ml-1 mb-1"/>
          </div>
          <span className="font-bold text-xs text-color-000 italic">
                        {`-- ${source_text} --`}
                    </span>
        </div>
      </div>
    )

    const TitleTopic = () => (
      <div className="space-y-1">
        <div className="flex gap-2 text-green-700">
          <GiIronCross size={14} style={{marginTop: 5}}/>
          <span className="flex-1 font-bold text-lg leading-snug">
                        {title}
                    </span>
        </div>
        {/*{renderIf(*/}
        {/*    description,*/}
        {/*    <div className="ml-6 text-xs text-color-500 italic whitespace-pre-line">*/}
        {/*        {description}*/}
        {/*    </div>*/}
        {/*)}*/}
      </div>
    )

    return (
      <div className="flex flex-col gap-1 111-111">
        {renderIf(
          content,
          <ContentWordOfGod content={content?.split('"')}/>
        )}
        <div className="flex items-baseline gap-3 border-b mb-4">
          <GiSpellBook size={16} className="text-color-300"/>
          <div className="font-medium text-sm text-color-300 uppercase tracking-wide">
            {t('meditate on God Word')}
          </div>
        </div>
        <div className="space-y-3">
          <TitleTopic/>
          {renderIf(
            _.some([meditation_content, meditation]),
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <GoDotFill className="text-color-400"/>
                <span className="text-color-400 whitespace-no-wrap italic">
                                    {`${t('content a meditation')} : `}
                                </span>
              </div>
              {renderIfElse(
                meditation_content,
                <div style={{marginLeft: 15, fontSize: '1.2rem'}}>
                  <SlateRenderer value={convertFromString(meditation_content)}/>
                </div>,
                <span style={{marginLeft: 21, fontSize: '1.2rem'}}>
                                    {meditation}
                                </span>,
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div style={style} className={classNames('flex flex-col', className)}>
      {header}
      <div
        style={style2}
        className={classNames('flex flex-col gap-3', className2)}>
        {renderIfElse(
          item,
          <EntityList
            apiInfo={apiInfo}
            refreshKey={refreshKey}
            query={{
              ':id': item?.id,
            }}
            RenderEntity={React.Fragment}
            renderItem={(e, i) => (
              <div className="flex flex-col">
                <div className="flex gap-2">
                  <GiIronCross size={10} style={{marginTop: 5}} className="text-green-700"/>
                  <span className="flex-1 font-bold text-sm text-green-700 italic leading-snug max-lines-2">
                                            {e?.title}
                                        </span>
                </div>
                <span className="ml-4 text-xs text-color-300 italic max-lines-3">
                                        {e?.description}
                                    </span>
                <Toggle>
                  {(isToggle, toggle) => (
                    <React.Fragment>
                      <div onClick={toggle}
                           className="mt-1 text-right text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                        {`${t('view detail')}...`}
                      </div>
                      {renderIf(
                        isToggle,
                        <Modal
                          title={
                            <div className="text-center font-bold text-sm text-color-000 uppercase tracking-wide">
                              {t('view a meditation')}
                            </div>
                          }
                          width={600}
                          className="custom-modal"
                          open={true}
                          footer={null}
                          destroyOnHidden={true}
                          onCancel={toggle}>
                          <ContentModal index={i} item={e}/>
                          <div className="flex justify-end p-3 mt-6 md:mt-8">
                                                            <span onClick={toggle}
                                                                  className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                                                                {t('close')}
                                                            </span>
                          </div>
                        </Modal>
                      )}
                    </React.Fragment>
                  )}
                </Toggle>
              </div>
            )}
          />,
          <div className="border border-color-50 rounded-lg">
            <EmptyHolder/>
          </div>
        )}
      </div>
    </div>
  )
}

export const MeditationsBlock = () => {

  const t = useTranslate()
  const {item} = useContext(WoGContext);
  const {liturgical_texts = []} = item ?? {}

  return (
    <div className="flex flex-col gap-4 px-2 py-4">
      <div className="flex items-baseline gap-3 border-b border-primary-500">
        <GiSpellBook size={16} className="text-primary-500"/>
        <div className="font-bold text-sm text-primary-500 uppercase tracking-wide">
          {t('meditate on God Word')}
        </div>
      </div>
      <div className="flex flex-col gap-6">
        {liturgical_texts.map((e, i) => {
          const {title, description, meditation, meditation_content} = e ?? {}
          const TitleTopic = () => (
            <div className="space-y-1">
              <div className="flex gap-2 text-green-700">
                <GiIronCross size={12} style={{marginTop: 5}}/>
                <span className="flex-1 font-bold leading-snug">
                    {title}
                </span>
              </div>
            </div>
          )
          return (
            <div key={i} className="flex flex-col gap-3">
              <TitleTopic/>
              {renderIf(
                _.some([meditation_content, meditation]),
                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <GoDotFill size={12} className="text-color-400"/>
                    <span className="text-sm text-color-400 whitespace-no-wrap italic">
                                            {`${t('content a meditation')} : `}
                                        </span>
                  </div>
                  {renderIfElse(
                    meditation_content,
                    <div style={{marginLeft: 12, fontSize: '1.125rem'}}>
                      <SlateRenderer value={convertFromString(meditation_content)}/>
                    </div>,
                    <span style={{marginLeft: 21, fontSize: '1.125rem'}}>
                                            {meditation}
                                        </span>,
                  )}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

const RelatedHashTags = ({}) => {
  const t = useTranslate()
  const wog_hashtags = useRouteSearchParam("wog_hashtags") || "";
  return (
    <div className="flex flex-col gap-4 px-0 md:px-2 py-0 md:py-4">
      <div className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
        {t('topics')}
      </div>
      <TagCloudWoGHashTags minHeight={350}/>
      <WoGByHashTag hashtags={decodeURIComponent(wog_hashtags)}/>
    </div>
  )
}

export const BookLinkedByWoGBlock = (props) => (
  <Block
    {...props}
    header={
      <Translate>
        {(t) => (
          <div
            className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
            {t('gospel information')}
          </div>
        )}
      </Translate>
    }>
    <BookLinkedByWoG {...props} />
  </Block>
)

export const LinkedByHashTagBlock = (props) => (
  <Block
    {...props}
    header={
      <Translate>
        {(t) => (
          <div
            className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
            {t('divine word related')}
          </div>
        )}
      </Translate>
    }>
    <WoGLinkedByHashTag {...props} />
  </Block>
)

export const CloudTagsBlock = (props) => (
  <Block
    {...props}
  >
    <RelatedHashTags {...props} />
  </Block>
)

export const MeditationBlock = (props) => (
  <Block
    {...props}
    header={
      <Translate>
        {(t) => (
          <div
            className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
            {t('the meditation on God Word')}
          </div>
        )}
      </Translate>
    }>
    <WoGMeditaions {...props} />
  </Block>
)


export const wogSideMenu = {
  bookLinkedByWoG: {
    key: 'book-by-word-of-god',
    label: 'book',
    icon: (
      <FaCircleInfo size={21}/>
    ),
    Component: (props) => (
      <BookLinkedByWoG
        {...props}
        className="gap-4 px-2 py-4"
        header={
          <Translate>
            {(t) => (
              <div
                className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
                {t('gospel information')}
              </div>
            )}
          </Translate>
        }
      />
    ),
  },
  linkedByHashTag: {
    key: 'linked-by-hash-tags',
    label: 'divine word related',
    icon: (
      <Badge count={<BsLink size={18} className="text-green-700"/>}>
        <BiSolidNetworkChart size={21}/>
      </Badge>
    ),
    Component: (props) => (
      <WoGLinkedByHashTag
        {...props}
        className="gap-4 px-2 py-4"
        header={
          <Translate>
            {(t) => (
              <div
                className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
                {t('divine word related')}
              </div>
            )}
          </Translate>
        }
      />
    ),
  },
  cloudTags: {
    key: 'cloud-tags',
    label: 'topics',
    icon: (
      <Badge count={<FaHashtag size={14} className="text-green-700"/>}>
        <MdTopic size={21}/>
      </Badge>
    ),
    Component: (props) => (
      <RelatedHashTags/>
    ),
  },
  meditations: {
    key: 'meditations',
    label: 'the meditation on God Word',
    icon: (
      <FaPrayingHands size={21}/>
    ),
    Component: (props) => (
      <WoGMeditaions
        {...props}
        className="gap-4 px-2 py-4"
        header={
          <Translate>
            {(t) => (
              <div
                className="border-b border-primary-500 font-bold text-sm text-primary-500 uppercase tracking-wide">
                {t('the meditation on God Word')}
              </div>
            )}
          </Translate>
        }
      />
    ),
  },
}
